import type { OrderSummary, ReviewOrderState } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { MyOrderRow } from './my-order-row';

interface MyOrderTableProps {
  readonly rows: readonly OrderSummary[];
  /** 주문 id 별 후기 상태 — 아직 못 읽었으면 undefined(버튼을 두지 않는다). */
  readonly reviewStates: ReadonlyMap<string, ReviewOrderState> | undefined;
}

const HEAD_CLASS = 'pb-3 pr-4 text-xs font-normal text-muted-foreground last:pr-0';

/** 내 주문 표 — 내 견적 표와 같은 결(상자 없이 굵은 머리선과 얇은 줄 선). */
export const MyOrderTable = ({ rows, reviewStates }: MyOrderTableProps): ReactElement => (
  <table aria-label="내 주문 목록" className="w-full text-sm">
    <thead className="text-left">
      <tr className="border-b border-foreground">
        <th scope="col" className={`${HEAD_CLASS} pl-1 sm:pl-2`}>
          주문 번호
        </th>
        <th scope="col" className={HEAD_CLASS}>
          상품명
        </th>
        <th scope="col" className={`${HEAD_CLASS} hidden text-right md:table-cell`}>
          수량
        </th>
        <th scope="col" className={`${HEAD_CLASS} hidden md:table-cell`}>
          주문일
        </th>
        <th scope="col" className={`${HEAD_CLASS} hidden md:table-cell`}>
          상태
        </th>
        <th scope="col" className={`${HEAD_CLASS} text-right`}>
          주문 금액
        </th>
        <th scope="col" className={`${HEAD_CLASS} hidden lg:table-cell`}>
          <span className="sr-only">상세</span>
        </th>
      </tr>
    </thead>
    <tbody>
      {rows.map((row) => (
        <MyOrderRow key={row.id} row={row} reviewState={reviewStates?.get(row.id)} />
      ))}
    </tbody>
  </table>
);
